<template>
    <div class="mt-3">
        
      <b-form-group
        label="Country"
        label-for="nested-state"
        label-cols-sm="3"
        label-align-sm="top"
      >
        <b-form-select v-model="country" :options="countries"></b-form-select>
    </b-form-group>
    <b-form-group
    label="Region"
    label-for="nested-state"
    label-cols-sm="3"
    label-align-sm="top"
    >
        <b-form-select v-model="region" :options="regions"></b-form-select>
    </b-form-group>
    <b-form-group
    label="District"
    label-for="nested-state"
    label-cols-sm="3"
    label-align-sm="top"
    >
        <b-form-select v-model="district" :options="districts"></b-form-select>
    </b-form-group>
    <b-form-group
    label="Groups"
    label-for="nested-state"
    label-cols-sm="3"
    label-align-sm="top"
    >
        <b-form-select v-model="team" :options="teams"></b-form-select>
    </b-form-group>


  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name:"GroupTeacherSearch",
     data() {
      return {
        selected: null,
        country:null,
        region:null,
        district:null,
        team:null,
        regions:[],
        countries:[],
        districts:[],
        teams:[],
        teamsAll:[]
      }
    },
    methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
        GET_GROUPS: "groups/GET_GROUPS",
        GET_GROUP_TEACHERS_BY_ID:"groups/GET_GROUP_TEACHERS_BY_ID"
    }),
    getRegions() {
      if (this.country && this.country.length > 0) {
        this.regions = [];
        this.optionsList.forEach((element) => {
          if (element.key == this.country + "Regions") {
            this.regionId = element.id;
            element.values.forEach((value) => {
              this.regions.push(
               // value: element.values.indexOf(value),
               // text: value,
               value
              );
            });
          }
        });
      }
    },
    getDistricts() {
      if (this.region && this.region.length > 0) {
        this.districts = [];
        this.optionsList.forEach((element) => {
          if (element.key == this.country + this.region + "Districts") {
            this.districtId = element.id;
            element.values.forEach((value) => {
              this.districts.push(
               // id: element.values.indexOf(value),
               // option: value,
               value
              );
            });
          }
        });
      }
    },
    getTeams(){
        if(this.country && !this.region && !this.district){
         
            this.teams = this.teamsAll.filter((e)=> e.country.trim() == this.country.trim());
        }else if(this.region && !this.district){
          
            this.teams = this.teamsAll.filter((e)=>{ 
               return e.region.trim() == this.region && e.country.trim() == this.country.trim()
            });
        }else if(this.country && this.region && this.district){
           
            this.teams = this.teamsAll.filter((e)=>{ 
               return e.district.trim() == this.district.trim() && e.region.trim() == this.region.trim() && e.country.trim() == this.country.trim()
            });
        }
    },
    fetchTeams(){
        var tmpGroups = this.$store.state.groups.groups;
        tmpGroups.forEach((e)=>{
            this.teamsAll.push({value:e.uuid,text:e.group_name,country:e.country,region:e.region,district:e.district})
        })
    }
  },
  computed: {
    optionsList: {
      get() {
        return this.$store.state.optionsList.optionsList;
      },
    },
    // countries: {
    //   get() {
    //     return this.$store.state.optionsList.countries;
    //   },
    // },
  },
  watch: {
    country() {
      // Clear previously selected values
      this.regions = [];
      this.districts = [];
      this.district = "";
      this.region ="";
      this.getRegions();
      this.getTeams();
    },
    region() {
      // Clear previously selected values
      this.districts = [];
      this.district = "";
      this.getDistricts();
      this.getTeams();
    },
    district(){
      this.getTeams();
    },
    team(){
       
        this.GET_GROUP_TEACHERS_BY_ID(this.team);
    }
  },
  created() {
    this.getRegions();
    this.getDistricts();
  },
  async mounted() {
    await this.GET_OPTIONS();
    await this.GET_GROUPS();
    this.countries = this.$store.state.optionsList.countries;
   // this.teamsAll = this.$store.state.groups.groups;
   this.fetchTeams();
  },
}
</script>